/**
 * Guardian page: 4-digit PIN gate, then the dashboard.
 */

import { useState } from "react";

import { useSession } from "@/app/useSession";
import { Dashboard } from "@/features/guardian/Dashboard";

export function GuardianPage() {
  const { guardianUnlocked, unlockGuardian } = useSession();
  const [pin, setPin] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [checking, setChecking] = useState(false);

  if (guardianUnlocked) {
    return <Dashboard />;
  }

  async function handleSubmit(event: React.FormEvent) {
    event.preventDefault();
    setChecking(true);
    setError(null);
    const ok = await unlockGuardian(pin);
    setChecking(false);
    if (!ok) {
      setError("That PIN didn't match. Please try again.");
      setPin("");
    }
  }

  return (
    <form onSubmit={handleSubmit} aria-label="Guardian sign in">
      <h1 style={{ fontSize: "2rem" }}>Grown-ups only</h1>
      <label htmlFor="pin" style={{ display: "block", fontSize: "1.25rem" }}>
        Enter your 4-digit PIN
      </label>
      <input
        id="pin"
        type="password"
        inputMode="numeric"
        autoComplete="off"
        pattern="[0-9]*"
        maxLength={4}
        value={pin}
        onChange={(e) => setPin(e.target.value.replace(/\D/g, ""))}
        style={{
          fontSize: "2rem",
          letterSpacing: "0.5rem",
          padding: "0.5rem 1rem",
          width: "8rem",
          textAlign: "center",
          borderRadius: "var(--radius-kid)",
          border: "3px solid var(--color-grape)",
          marginBottom: "1rem",
          display: "block",
        }}
      />
      {error && (
        <p role="alert" style={{ color: "var(--color-grape)" }}>
          {error}
        </p>
      )}
      <button
        type="submit"
        className="kid-button kid-button--primary"
        disabled={pin.length !== 4 || checking}
      >
        {checking ? "Checking…" : "Unlock"}
      </button>
    </form>
  );
}
